import summary from './summary'

import marked from 'marked'

// import hljs from 'highlight.js';

const transform2HTML = (filePath) => {
  // marked.setOptions({
  //   highlight: code => hljs.highlightAuto(code).value,
  // });

  return fetch(filePath)
    .then(response => response.text())
    .then(text => marked(text))
}

const getHomePageFile = () => (summary.find(it => it.shownInHomePage).file)

export const getFileList = () => (summary)

export const getHomePageArticle = () => {
  const filePath = getHomePageFile()
  return transform2HTML(filePath)
}

export const getArticle = (name) => {
  var filePath = getHomePageFile()
  try {
    filePath = summary.find(it => it.name === name)
      .file
  } catch (error) {
    console.log('getArticle Failed', error)
  }

  return transform2HTML(filePath)
}



// WEBPACK FOOTER //
// ./src/articles/index.js